import { Controller } from '@hotwired/stimulus'

// The history of a long standing subscription is rendered whole, so it survives without
// javascript; here it stands on the newest entries and grows a page at a time.
export default class extends Controller {
  static targets = ['entry', 'toggle', 'more', 'less']

  static values = {
    firstPage: { type: Number, default: 5 },
    page: { type: Number, default: 10 },
  }

  connect() {
    this.visible = this.firstPageValue
    this.render()
  }

  toggle() {
    this.visible = this.expanded
      ? this.firstPageValue
      : this.visible + this.pageValue
    this.render()
  }

  render() {
    this.entryTargets.forEach((entry, index) => {
      entry.hidden = index >= this.visible
    })

    this.toggleTarget.hidden = this.entryTargets.length <= this.firstPageValue
    this.moreTarget.hidden = this.expanded
    this.lessTarget.hidden = !this.expanded
    this.toggleTarget.firstElementChild.ariaExpanded = String(this.expanded)
  }

  get expanded() {
    return this.visible >= this.entryTargets.length
  }
}
